import React from 'react'

import img300 from '@assets/html/dist/img/img-300x300.png'
import imgRightTitle1 from '@assets/html/dist/img/right-title-1.png'
import imgRightImg1 from '@assets/html/dist/img/right-img-1.png'
import imgRightTitle2 from '@assets/html/dist/img/right-title-2.png'
import imgRightImg2 from '@assets/html/dist/img/right-img-2.png'

type Props = {
  //
}

const RightSidebar: React.FC<Props> = () => (
  <div className="right-sidebar">
    <img src={img300} style={{ marginBottom: 10 }} alt="" />
    <img src={img300} alt="" />
    <div className="mt-2 text-center">
      <img src={imgRightTitle1} alt="" />
      <img src={imgRightImg1} alt="" />
    </div>
    <div className="mt-2 text-center">
      <img src={imgRightTitle2} alt="" />
      <img src={imgRightImg2} alt="" />
    </div>
  </div>
)

export default RightSidebar
